export const scrollToEmptyInput = () => {
  let maxTop = 10000;
  let element: Element | null = null;
  // eslint-disable-next-line max-len
  document.querySelectorAll('[data-field-wrapper][data-has-value="0"][data-ignore-scroll-to="0"],[data-submit-button][data-ignore-scroll-to="0"]').forEach((el) => {
    if (el.getBoundingClientRect().top < maxTop && el.getBoundingClientRect().height) {
      maxTop = el.getBoundingClientRect().top;
      element = el;
    }
  });
  if (element) {
    const customSelector = (element as Element).getAttribute('data-scroll-anchor-selector');
    let anchor = (element as Element).querySelector('[data-scroll-anchor]') || (element as Element);
    if (customSelector) {
      anchor = (element as Element).closest(customSelector) || anchor;
    }
    anchor.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
};
